import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import ModalHeader from "./ModalHeader";
import styled from "styled-components";

const Content = styled(DialogContent)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  background-color: #000;
  color: white;
`;

const Footer = styled(DialogActions)`
  border-top: 1px solid #fff;
  background-color: #000;
  padding: 10px;
  font-size: 14px;
`;

const ConfirmDeleteModal = ({ open, onClose, onConfirm, loading }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <ModalHeader title={"Permanently Delete Record?"}></ModalHeader>
      <Content>
        <Typography>This action cannot be undone!</Typography>
      </Content>
      <Footer>
        <Button onClick={onClose} color="inherit" disabled={loading}>
          Cancel
        </Button>
        <Button onClick={onConfirm} color="error" disabled={loading}>
          {loading ? (
            <CircularProgress size={20} style={{ color: "white" }} />
          ) : (
            "Delete"
          )}
        </Button>
      </Footer>
    </Dialog>
  );
};

export default ConfirmDeleteModal;
